// extracted by mini-css-extract-plugin
export const root = "gridItem-modules--root--2CwhX";
export const border = "gridItem-modules--border--1HvYw";
export const description = "gridItem-modules--description--3k2Ix";